var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { safeAssign } from "./safe-assign";
export class BirthdayEventDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BirthdayEventDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BirthdayEventDTO.prototype, "employeeName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BirthdayEventDTO.prototype, "birthday", void 0);
export class AbsenceEventDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AbsenceEventDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], AbsenceEventDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceEventDTO.prototype, "employeeName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceEventDTO.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceEventDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], AbsenceEventDTO.prototype, "end", void 0);
export class ExpiringContractEventDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExpiringContractEventDTO.prototype, "contractId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExpiringContractEventDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExpiringContractEventDTO.prototype, "employeeName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExpiringContractEventDTO.prototype, "end", void 0);
export class ExpiringProbationEventDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExpiringProbationEventDTO.prototype, "contractId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ExpiringProbationEventDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExpiringProbationEventDTO.prototype, "employeeName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ExpiringProbationEventDTO.prototype, "probationEnd", void 0);
export class TodaysEventsDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    Type(() => BirthdayEventDTO),
    __metadata("design:type", Array)
], TodaysEventsDTO.prototype, "todaysBirthdays", void 0);
__decorate([
    Expose(),
    Type(() => BirthdayEventDTO),
    __metadata("design:type", Array)
], TodaysEventsDTO.prototype, "tomorrowsBirthdays", void 0);
__decorate([
    Expose(),
    Type(() => AbsenceEventDTO),
    __metadata("design:type", Array)
], TodaysEventsDTO.prototype, "currentVacationAbsences", void 0);
__decorate([
    Expose(),
    Type(() => AbsenceEventDTO),
    __metadata("design:type", Array)
], TodaysEventsDTO.prototype, "currentSickAbsences", void 0);
__decorate([
    Expose(),
    Type(() => AbsenceEventDTO),
    __metadata("design:type", Array)
], TodaysEventsDTO.prototype, "recentlyUpdatedVacationRequests", void 0);
__decorate([
    Expose(),
    Type(() => AbsenceEventDTO),
    __metadata("design:type", Array)
], TodaysEventsDTO.prototype, "recentlyUpdatedSickRequests", void 0);
__decorate([
    Expose(),
    Type(() => ExpiringContractEventDTO),
    __metadata("design:type", Array)
], TodaysEventsDTO.prototype, "expiringContracts", void 0);
__decorate([
    Expose(),
    Type(() => ExpiringProbationEventDTO),
    __metadata("design:type", Array)
], TodaysEventsDTO.prototype, "expiringProbations", void 0);
//# sourceMappingURL=todays-events.dto.js.map